module.exports = __webpack_public_path__ + "VIPV21.png?9b0e5674dfe57cebaa2c8cb66bc9e246";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/colours/horses/VIPV21.png
// module id = 116
// module chunks = 0